module.exports = __webpack_public_path__ + "img/georgia.d958341e.svg";